import React, { Component } from 'react'
import {
  Input,
  Form,
  Modal,
  Popconfirm,
  Button,
  DatePicker,
  Switch,
  InputNumber,
  AutoComplete
} from 'antd'
import styled from 'styled-components'
import moment from 'moment'
import Attachments from './Attachments'
import Notes from './Notes'
import ScheduledDeliveries from '../VehiclesScheduledDeliveries'
import FollowUps from '../FollowUps'
import CurrencyInput from 'react-currency-input'
import { removeCurrencyMarkup } from '../../util'

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`

const FormItem = Form.Item
const { TextArea } = Input
const Option = AutoComplete.Option

class AddEditForm extends Component {
  handleCreateVehicle = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      values.year = values.year ? values.year : null
      values.created_by_id = this.props.userId
      values.updated_by_id = this.props.userId
      values.inspection_expiration_date = values.inspection_expiration_date
        ? moment(values.inspection_expiration_date).format('YYYY/MM/DD HH:mm:ss')
        : null
      values.insurance_expiration_date = values.insurance_expiration_date
        ? moment(values.insurance_expiration_date).format('YYYY/MM/DD HH:mm:ss')
        : null
      values.purchased_date = values.purchased_date
        ? moment(values.purchased_date).format('YYYY/MM/DD HH:mm:ss')
        : null
      values.registration_expiration_date = values.registration_expiration_date
        ? moment(values.registration_expiration_date).format('YYYY/MM/DD HH:mm:ss')
        : null
      values.purchased_price = removeCurrencyMarkup(values.purchased_price)
      values.purchased_miles = removeCurrencyMarkup(values.purchased_miles)
      this.props.handleAddVehicle(values)
      form.resetFields()
    })
  }

  handleEditVehicle = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      values.updated_by_id = this.props.userId
      values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')
      values.inspection_expiration_date = values.inspection_expiration_date
        ? moment(values.inspection_expiration_date).format('YYYY/MM/DD HH:mm:ss')
        : null
      values.insurance_expiration_date = moment(values.insurance_expiration_date).format(
        'YYYY/MM/DD HH:mm:ss'
      )
      values.purchased_date = moment(values.purchased_date).format('YYYY/MM/DD HH:mm:ss')
      values.registration_expiration_date = moment(values.registration_expiration_date).format(
        'YYYY/MM/DD HH:mm:ss'
      )
      values.purchased_price = removeCurrencyMarkup(values.purchased_price)
      values.purchased_miles = removeCurrencyMarkup(values.purchased_miles)
      this.props.handleEditVehicle(values)
      form.resetFields()
    })
  }

  getDriverOptions = () => {
    const { employees } = this.props
    if (employees && employees.length > 0) {
      return employees.map(employee => {
        const employeeName = `${employee.first_name} ${employee.last_name}`
        return <Option value={employeeName}>{employeeName}</Option>
      })
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { modalVisible, currentVehicle, handleToggleAddEditForm } = this.props
    return (
      <Modal
        visible={modalVisible}
        title="Vehicle"
        okText={currentVehicle ? 'Save Changes' : 'Add Vehicle'}
        onCancel={handleToggleAddEditForm}
        onOk={currentVehicle ? this.handleEditVehicle : this.handleCreateVehicle}
        width={'95%'}
        maskClosable={false}
      >
        <Form layout="vertical">
          {currentVehicle && (
            <div>
              <div className="row">
                <div className="col-4">
                  <strong>Created Date</strong>
                </div>
                <div className="col-4">
                  <strong>Updated Date</strong>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  {moment(currentVehicle.created_date).format('M/D/YYYY')}
                </div>
                <div className="col-4">
                  {moment(currentVehicle.updated_date).format('M/D/YYYY')}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-4">
                  <strong>Created By</strong>
                </div>
                <div className="col-4">
                  <strong>Updated By</strong>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-4">{`${currentVehicle.created_by_first_name} ${
                  currentVehicle.created_by_last_name
                }`}</div>
                <div className="col-4">{`${currentVehicle.updated_by_first_name} ${
                  currentVehicle.updated_by_last_name
                }`}</div>
              </div>
              <FormItem label="Set Status">
                <div className="row">
                  <div className="col-md-12">
                    <Switch
                      checkedChildren="Active"
                      unCheckedChildren="Inactive"
                      defaultChecked={currentVehicle.status === 'active' ? true : false}
                      onChange={this.props.setStatusVehicle}
                    />
                  </div>
                </div>
              </FormItem>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Name">
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: 'Name cannot be blank.'
                    }
                  ],
                  initialValue: currentVehicle ? currentVehicle.name : ''
                })(<Input placeholder="Enter first name..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: currentVehicle ? currentVehicle.description : ''
                })(<TextArea placeholder="Enter description..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <FormItem label="Year">
                {getFieldDecorator('year', {
                  initialValue: currentVehicle ? currentVehicle.year : ''
                })(<InputNumber placeholder="Enter the year..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Make">
                {getFieldDecorator('make', {
                  initialValue: currentVehicle ? currentVehicle.make : ''
                })(<Input placeholder="Enter the year..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Model">
                {getFieldDecorator('model', {
                  initialValue: currentVehicle ? currentVehicle.model : ''
                })(<Input placeholder="Enter the model..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <FormItem label="Color">
                {getFieldDecorator('color', {
                  initialValue: currentVehicle ? currentVehicle.color : ''
                })(<Input placeholder="Enter the color..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="VIN">
                {getFieldDecorator('vin', {
                  initialValue: currentVehicle ? currentVehicle.vin : ''
                })(<Input placeholder="Enter the VIN..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="License Plate">
                {getFieldDecorator('license_plate', {
                  initialValue: currentVehicle ? currentVehicle.license_plate : ''
                })(<Input placeholder="Enter the license plate..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <FormItem label="Purchased Date">
                {getFieldDecorator('purchased_date', {
                  initialValue:
                    currentVehicle && currentVehicle.purchased_date
                      ? moment(currentVehicle.purchased_date)
                      : null
                })(<StyledDatePicker placeholder="Choose purchase date..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Purchased Miles">
                {getFieldDecorator('purchased_miles', {
                  initialValue: currentVehicle ? currentVehicle.purchased_miles : ''
                })(
                  <CurrencyInput
                    className="ant-input"
                    precision="0"
                    placeholder="Enter purchased miles..."
                  />
                )}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Purchased Price">
                {getFieldDecorator('purchased_price', {
                  initialValue: currentVehicle ? currentVehicle.purchased_price : ''
                })(
                  <CurrencyInput
                    className="ant-input"
                    prefix="$"
                    placeholder="Enter purchased price..."
                  />
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <FormItem label="Insurance Company">
                {getFieldDecorator('insurance_company', {
                  initialValue: currentVehicle ? currentVehicle.insurance_company : ''
                })(<Input placeholder="Enter insurance company..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Insurance Expiration">
                {getFieldDecorator('insurance_expiration_date', {
                  rules: [
                    {
                      required: true,
                      message: 'Insurance Expiration cannot be blank.'
                    }
                  ],
                  initialValue:
                    currentVehicle && currentVehicle.insurance_expiration_date
                      ? moment(currentVehicle.insurance_expiration_date)
                      : null
                })(<StyledDatePicker placeholder="Enter insurance expiration..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Driver">
                {getFieldDecorator('driver', {
                  rules: [
                    {
                      required: false,
                      message: 'You must choose a type'
                    }
                  ],
                  initialValue: currentVehicle ? currentVehicle.driver : ''
                })(
                  <AutoComplete
                    placeholder="Choose the Driver"
                    style={{ width: '100%' }}
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                  >
                    {this.getDriverOptions()}
                  </AutoComplete>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <FormItem label="EZ Pass Tag Number">
                {getFieldDecorator('ez_pass_tag_number', {
                  initialValue: currentVehicle ? currentVehicle.ez_pass_tag_number : ''
                })(<Input placeholder="Enter EZ Pass..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Registration Number">
                {getFieldDecorator('registration_number', {
                  initialValue: currentVehicle ? currentVehicle.registration_number : ''
                })(<Input placeholder="Enter registration number..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Registration Expiration">
                {getFieldDecorator('registration_expiration_date', {
                  rules: [
                    {
                      required: true,
                      message: 'Registration Expiration cannot be blank.'
                    }
                  ],
                  initialValue:
                    currentVehicle && currentVehicle.registration_expiration_date
                      ? moment(currentVehicle.registration_expiration_date)
                      : null
                })(<StyledDatePicker placeholder="Enter reg. expiration..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <FormItem label="Registered As">
                {getFieldDecorator('registered_as', {
                  initialValue: currentVehicle ? currentVehicle.registered_as : ''
                })(<Input placeholder="Enter Registered As..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Inspection Expiration">
                {getFieldDecorator('inspection_expiration_date', {
                  rules: [
                    {
                      required: true,
                      message: 'Inspection Expiration cannot be blank.'
                    }
                  ],
                  initialValue:
                    currentVehicle && currentVehicle.inspection_expiration_date
                      ? moment(currentVehicle.inspection_expiration_date)
                      : null
                })(<StyledDatePicker placeholder="Enter reg. expiration..." />)}
              </FormItem>
            </div>
            <div className="col-md-4">
              <FormItem label="Purpose">
                {getFieldDecorator('purpose', {
                  initialValue: currentVehicle ? currentVehicle.registered_as : ''
                })(<Input placeholder="Enter Purpose..." />)}
              </FormItem>
            </div>
          </div>
        </Form>
        {currentVehicle && (
          <div className="row">
            <div className="col-md-6">
              <Notes
                notes={this.props.notes}
                handleToggleNoteEditArea={this.props.handleToggleNoteEditArea}
                noteAddEditContainer={this.props.noteAddEditContainer}
                userId={this.props.userId}
                createNote={this.props.createNote}
                currentNote={this.props.currentNote}
                handleRowNoteClick={this.props.handleRowNoteClick}
                updateNote={this.props.updateNote}
                deleteNote={this.props.deleteNote}
              />
            </div>
            <div className="col-md-6">
              <FollowUps
                followUps={this.props.followUps}
                handleToggleFollowUpEditArea={this.props.handleToggleFollowUpEditArea}
                followUpAddEditContainer={this.props.followUpAddEditContainer}
                userId={this.props.userId}
                createFollowUp={this.props.createFollowUp}
                currentFollowUp={this.props.currentFollowUp}
                handleRowFollowUpClick={this.props.handleRowFollowUpClick}
                updateFollowUp={this.props.updateFollowUp}
                deleteFollowUp={this.props.deleteFollowUp}
                autocompleteUsers={this.props.autocompleteUsers}
                autocompleteRoles={this.props.autocompleteRoles}
                followUpAssignToType={this.props.followUpAssignToType}
                changeAssignedToType={this.props.changeAssignedToType}
                handleResetFollowUpForm={this.props.handleResetFollowUpForm}
              />
            </div>
          </div>
        )}
        <div class="row">
          <div class="col-md-12">
            <ScheduledDeliveries
              scheduledDeliveries={this.props.scheduledDeliveries}
              deleteScheduledDelivery={this.props.deleteScheduledDelivery}
            />
          </div>
        </div>
        {currentVehicle && (
          <Attachments
            currentId={this.props.currentId}
            userId={this.props.userId}
            attachmentList={this.props.attachmentList}
            loadingAttachments={this.props.loadingAttachments}
            uploadingAttachment={this.props.uploadingAttachment}
            uploadAttachment={this.props.uploadAttachment}
            updateAttachmentDescription={this.props.updateAttachmentDescription}
            deleteAttachment={this.props.deleteAttachment}
            deletingAttachment={this.props.deletingAttachment}
          />
        )}
        {currentVehicle && (
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.props.handleDeleteVehicle}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            {currentVehicle && <Button type="danger" icon="delete" />}
          </Popconfirm>
        )}
      </Modal>
    )
  }
}

export default Form.create()(AddEditForm)



// WEBPACK FOOTER //
// ./src/components/vehicles/AddEditForm.js